import {React} from '@api';
import {View} from "@react-pdf/renderer";
import {observer} from 'mobx-react';
import {styled} from '@pdf'

const Root = styled.View`
  width: 0.2cm;
  height: 0.2cm;
  max-width:100%;
  max-height:100%;
  margin: 0 auto;
  flex-grow:0;
  border-style: solid;
   border-width: 1px;
   border-color: #dedede;
`

const LargeRoot = styled.View`
  height:      140px;
  width:100%;
  margin: auto auto 0 auto;
  flex-shrink:0;
  display:     flex;
  flex-direction: column;
`

export class HexPdf extends React.Component<{ hex: string, size?:any, style?: any }> {
  render() {
    const {props: {hex, style, size, ...props}} = this
    if(size=='big'){
      return <LargeRoot style={{backgroundColor: hex, ...style}}>
      </LargeRoot>
    }
    return <Root style={{backgroundColor: hex, ...style}}>
    </Root>
  }
}


// WEBPACK FOOTER //
// ./src/modules/pdf/productCard/HexPdf.tsx